import React, { useState } from "react";
// import "./Popup.css"; // You can style your popup in a separate CSS file

const Popup_TakeInputValue = ({
  onSavePopupInputCallBack,
  isOpen,
  onClose,
}) => {
  const [textInput, setTextInput] = useState("");

  const handleInputChange = (e) => {
    setTextInput(e.target.value);
  };

  const handleSave = () => {
    // Do something with the textInput value
    console.log("Text input:", textInput);
    onSavePopupInputCallBack(textInput);
    // Close the popup
    onClose();
  };

  return (
    <div style={{ zIndex: "1" }} className={`popup ${isOpen ? "open" : ""}`}>
      <div className="popup-content">
        <span className="close-btn" onClick={onClose}>
          <i
            className="fa fa-window-close"
            aria-hidden="true"
            style={{ fontSize: "24px", color: "red" }}
          ></i>
        </span>
        <h3 style={{ padding: "15px" }}>(Comment) Deliver Cloth To Customer</h3>
        <textarea
          id="w3review"
          name="w3review"
          rows="4"
          cols="50"
          onChange={handleInputChange}
        >
          {textInput}
        </textarea>

        {/* <input
          type="textarea"
          placeholder="Enter comment"
          value={textInput}
          onChange={handleInputChange}
        /> */}
        <button
          className="btn btn-primary px-3"
          style={{ marginTop: "15px" }}
          onClick={handleSave}
        >
          Save Comment
        </button>
      </div>
    </div>
  );
};

export default Popup_TakeInputValue;
